/*
* EVENT
* log a new client event in the database
*/

import axios from 'axios';

export function Event(name, metadata){
  try {
    axios.post('/api/event', {
      name: name,
      metadata: metadata
    }).catch(err => {
      console.error('Event post error (non-blocking):', err);
    });
  } catch (error) {
    console.error('Event function error (non-blocking):', error);
  }
}